import { HiDotsVertical } from 'react-icons/hi';
import { Dropdown } from 'flowbite-react';
import { filter, flatten, isEmpty } from 'lodash';

import './style.scss';

const Actions = ({ children }: any) => {
  const showChildren = filter(flatten([children]), (c: any) => c?.props?.show);
  const hileChildren = filter(flatten([children]), (c: any) => !c?.props?.show);
  return (
    <div className="more-action flex sm:mr-2">
      {showChildren}
      {!isEmpty(hileChildren) && (
        <Dropdown
          renderTrigger={() => (
            <div className="p-1.5 rounded bg-gray-100 mr-1.5 icon">
              <HiDotsVertical className="w-5 h-5" />
            </div>
          )}
          label={undefined}
        >
          {hileChildren}
        </Dropdown>
      )}
    </div>
  );
};

Actions.Item = ({ action, custom, label, show, icon }: any) => {
  if (show) {
    return (
      <div className="p-1.5 rounded bg-gray-100 mr-1.5 icon" onClick={action}>
        {icon}
      </div>
    );
  } else {
    return <Dropdown.Item onClick={action}>{custom || label} </Dropdown.Item>;
  }
};

export default Actions;
